import { Grid, theme } from '@zappyrent/hundop';
import React from 'react';
import Media from 'react-media';

import {
  StyledGridWrapper,
  StyledImageOuterWrapper,
  StyledTextInnerWrapper,
  StyledTextMiddleWrapper,
  StyledTextOuterWrapper,
  StyledWrapper,
} from './ReferALandlordIntro.styles';
import ReferALandlordIntroHeading from './ReferALandlordIntroHeading';
import ReferALandlordIntroImage from './ReferALandlordIntroImage';
import ReferALandlordIntroText from './ReferALandlordIntroText';

const ReferALandlordIntro = (): JSX.Element => {
  return (
    <StyledWrapper>
      <Media
        queries={{
          mobile: `(max-width: calc(${theme.breakpoints.l} - 1px))`,
          desktop: `(min-width: ${theme.breakpoints.l})`,
        }}
        defaultMatches={{ desktop: true }}
      >
        {matches => (
          <>
            {matches.mobile && (
              <>
                <ReferALandlordIntroHeading />
                <ReferALandlordIntroImage />
                <ReferALandlordIntroText />
              </>
            )}
            {matches.desktop && (
              <StyledTextOuterWrapper>
                <StyledTextMiddleWrapper>
                  <StyledGridWrapper>
                    <Grid container>
                      <StyledTextInnerWrapper>
                        <ReferALandlordIntroHeading />
                        <ReferALandlordIntroText />
                      </StyledTextInnerWrapper>
                    </Grid>
                  </StyledGridWrapper>
                </StyledTextMiddleWrapper>
                <StyledImageOuterWrapper>
                  <ReferALandlordIntroImage />
                </StyledImageOuterWrapper>
              </StyledTextOuterWrapper>
            )}
          </>
        )}
      </Media>
    </StyledWrapper>
  );
};

export default ReferALandlordIntro;
